import { services } from "@/service";

const state = {
  perssion: false,
  freeTime: false,
  buyVip: false,
  loginStatus: false,
  reportCases: []
}

const actions = {
  setPerssion({ commit }, value) {
    commit('getPession', value)
  },
  setFreeTime({ commit }, value) {
    commit('getFreeTime', value)
  },
  setBuyVip({ commit }, value) {
    commit('getBuyVip', value)
  },
  setLocalLogin({ commit }, value) {
    commit('getLocalLogin', value)
  },
  async refreshReportCases({ state }) {
    try {
      const { data = [], statusCode, message } = await services.caseRule.getReportCases();
      if (statusCode === 1) {
        state.reportCases = data;
      } else {
        throw new Error(message);
      }
    } catch (err) {
      state.reportCases = [];
      console.error(err);
    }
  }
}

const getters = {
  perssion: state => state.perssion,
  freeTime: state => state.freeTime,
  buyVip: state => state.buyVip,
  loginStatus: state => state.loginStatus,
  reportCases: state => state.reportCases,
  reportCaseIdEnum: state => {
    const caseIdEnum = {};
    state.reportCases.forEach(item => {
      caseIdEnum[item.caseId] = item.id;
    });
    return caseIdEnum;
  }
}

const mutations = {
  setPerssion(state, res) {
    state.perssion = res
  },
  setLocalLogin(state, res) {
    state.loginStatus = res
  },
  setFreeTime(state, res) {
    state.freeTime = res
  },
  setBuyVip(state, res) {
    state.buyVip = res
  }
}

export default {
  state,
  actions,
  getters,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js